export default {
  statementsOfNotSellingSites: []
}
